var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66459 7.18598V7.1626C8.65981 7.17044 8.6532 7.17828 8.64905 7.18598H8.66459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V16H16V0H0ZM4.9766 13.2924H2.60276V6.15054H4.9766V13.2924ZM3.78968 5.17577H3.774C2.97769 5.17577 2.46154 4.62716 2.46154 3.94145C2.46154 3.24069 2.99277 2.70762 3.80522 2.70762C4.61785 2.70762 5.11722 3.24069 5.13276 3.94145C5.13276 4.62716 4.61785 5.17577 3.78968 5.17577ZM13.5385 13.2924H11.164V9.47147C11.164 8.51179 10.8209 7.8567 9.96153 7.8567C9.30521 7.8567 8.9152 8.29778 8.74339 8.72503C8.68093 8.87764 8.66462 9.08979 8.66462 9.30381V13.2924H6.28969C6.28969 13.2924 6.32151 6.82057 6.28969 6.15058H8.66462V7.16259C8.98015 6.67706 9.54325 5.98291 10.8046 5.98291C12.3672 5.98291 13.5385 7.00339 13.5385 9.19691V13.2924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.057a1780f4e43dd66138a5176e247b19.svg";
export { ForwardRef as ReactComponent };